<template>
    <div class="result">
        <div class="inner" v-if="props.isSuccess">
            <iconpark-icon name="shimingrenzhengrenzhengchenggong"></iconpark-icon>
            <h4 style="color: #43CF7C;">认证成功</h4>
            <ul>
                <li>认证方式: {{ authWay[userInformation.authWay] }}</li>
                <li>身份证号码: {{ userInformation.idcardNumber || '-' }}</li>
                <li>认证时间: {{ userInformation.authInitTime ? formatDate(userInformation.authInitTime) : '-' }}</li>
            </ul>
        </div>
        <div class="inner" v-else>
            <iconpark-icon name="renzhengshibai"></iconpark-icon>
            <h4 style="color: #D43030;">认证失败</h4>
            <p>失败原因:打款金额不一致，请重新认证</p>
            <span class="auth-btn"  @click="emit('restart')">重新认证</span>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs'

const formatDate = (date) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

const store = useStore()
const props = defineProps({
    isSuccess: Boolean
})
const userInformation = computed(() => store.state.login.userInfo)
const emit = defineEmits(['restart'])
const authWay = ['', '微信', '支付宝', '填写资料认证']
const idcardType = ['', '身份证号']
</script>

<style scoped lang="scss">
.result {
    width: 100%;
    margin-top: 50rem;
    height: 580rem;
    background-color: #fff;
    border-radius: 10rem;
    overflow: hidden;
    iconpark-icon{
        font-size: 80rem;
    }
    .inner{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    h4{
        margin: 20rem 0; font-weight: bold; font-size: 24rem;
    }
    p{
        color: #383838; margin-top: 50rem;
    }
    ul{
        li{
            height: 40rem; line-height: 40rem;
        }
    }
}
.auth-btn {
    width: 200rem;
    height: 40rem;
    background: #000;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    margin-top: 150rem;
}
</style>
